import { httpClient, unwrap } from './httpClient';

export async function listPayments({ userIds, sortBy, sortDir, page, pageSize }) {
  const response = await httpClient.get('/admin/payments/', {
    params: {
      user_ids: userIds?.length ? userIds.join(',') : undefined,
      sort_by: sortBy,
      sort_dir: sortDir,
      page,
      page_size: pageSize,
    },
  });
  return unwrap(response);
}

const adminPaymentService = {
  listPayments,
};

export default adminPaymentService;
